import { render, staticRenderFns } from "./ChangeStatusTemplate.vue?vue&type=template&id=26c7fa47&lang=pug"
import script from "./ChangeStatusTemplate.vue?vue&type=script&lang=js"
export * from "./ChangeStatusTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports